module.exports = __webpack_public_path__ + "static/media/inbound-einvoice.3cf3ad07.svg";